export default {"src":"/_next/static/image/public/images/notify_me_tooltip.8c27c1e30dd9c9a599203fab140e8187.svg","height":32,"width":80};